import * as React from "react";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { Box, Grid, TextField } from "@mui/material";
import axios from "axios";

export default function RequestAccess({ lessThanXL }) {
  const [form, setForm] = React.useState({
    name: "",
    email: "",
    company: "",
  });

  const handleNameChange = (e) => {
    const { value } = e.target;
    setForm({
      ...form,
      name: value,
    });
  };
  const handleEmailChange = (e) => {
    const { value } = e.target;
    setForm({
      ...form,
      email: value,
    });
  };
  const handleCompanyChange = (e) => {
    const { value } = e.target;
    setForm({
      ...form,
      company: value,
    });
  };

  const requestAccess = () => {
    if (!form.email) {
      return;
    }
    axios.post("https://dokusense.ai/api/v1/accesses/request", {
      email: form.email,
      content: `${form.name || ""}${form.company ? "" + form.company : ""}`,
    });
  };
  return (
    <>
      <Grid mt={12} container spacing={1}>
        <Grid item md={12}>
          <Box
            sx={{
              textAlign: "center",
              paddingLeft: "40px",
              paddingRight: "40px",
            }}
          >
            <Typography
              component={"span"}
              fontWeight="700"
              sx={{
                textAlign: "center",
                color: "#1F1F1F",
              }}
              fontSize="36px"
              lineHeight={"normal"}
              gutterBottom
            >
              Ready to Transform the Way You Read Documents?
            </Typography>
            <br />
            <Typography
              fontWeight="700"
              component="span"
              fontSize="36px"
              sx={{
                fontStyle: !lessThanXL ? "italic" : "",
                background: (theme) => theme.palette.gradient.toTop,
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                lineHeight: "normal",
              }}
            >
              Get in Touch to Request Access
            </Typography>
          </Box>
        </Grid>
      </Grid>
      <Grid
        mt={11}
        container
        sx={{ display: "flex", justifyContent: "center" }}
      >
        <Grid item md={6} xs={10}>
          <TextField
            sx={{
              marginLeft: "auto",
              width: "100%",
              "& .MuiFilledInput-root": {
                backgroundColor: "#FFFFFF",
                borderRadius: "9px",
              },
              "& .MuiFilledInput-root.Mui-focused": {
                backgroundColor: "#FFFFFF",
              },
              "&:hover .MuiFilledInput-root": {
                backgroundColor: "#FFFFFF",
              },
            }}
            id="outlined-basic"
            label="First and Last Name"
            aria-label="First and Last Name"
            variant="filled"
            InputProps={{ disableUnderline: true }}
            value={form.name}
            onChange={(e) => handleNameChange(e)}
          />
        </Grid>
      </Grid>
      <Grid mt={2} container sx={{ display: "flex", justifyContent: "center" }}>
        <Grid item md={6} xs={10}>
          <TextField
            sx={{
              marginLeft: "auto",
              width: "100%",
              "& .MuiFilledInput-root": {
                backgroundColor: "#FFFFFF",
                borderRadius: "9px",
              },
              "& .MuiFilledInput-root.Mui-focused": {
                backgroundColor: "#FFFFFF",
              },
              "&:hover .MuiFilledInput-root": {
                backgroundColor: "#FFFFFF",
              },
            }}
            id="outlined-basic"
            label="Email Address"
            aria-label="Email Address"
            variant="filled"
            InputProps={{ disableUnderline: true }}
            value={form.email}
            onChange={(e) => handleEmailChange(e)}
          />
        </Grid>
      </Grid>
      <Grid mt={2} container sx={{ display: "flex", justifyContent: "center" }}>
        <Grid item md={6} xs={10}>
          <TextField
            sx={{
              marginLeft: "auto",
              width: "100%",
              "& .MuiFilledInput-root": {
                backgroundColor: "#FFFFFF",
                borderRadius: "9px",
              },
              "& .MuiFilledInput-root.Mui-focused": {
                backgroundColor: "#FFFFFF",
              },
              "&:hover .MuiFilledInput-root": {
                backgroundColor: "#FFFFFF",
              },
            }}
            id="outlined-basic"
            label="Company (Optional)"
            aria-label="Company (Optional)"
            variant="filled"
            InputProps={{ disableUnderline: true }}
            value={form.company}
            onChange={(e) => handleCompanyChange(e)}
          />
        </Grid>
      </Grid>
      <Grid mt={2} container sx={{ display: "flex", justifyContent: "center" }}>
        <Grid item>
          <Button
            variant="contained"
            sx={{ backgroundColor: "#466A88", borderRadius: "8px" }}
            onClick={requestAccess}
            aria-label="Submit Request Access"
          >
            Submit
          </Button>
        </Grid>
      </Grid>
    </>
  );
}
